import React from "react";
import ChangePassword from "../../ChangePassword/ChangePassword";

const ResetUserPasswordModal = ({user, onClose}) => {

    return (
        <div className="modal d-flex justify-content-center" style={{ display: user ? "block" : "none" }}>
            <div className="forgot-password-modal-wrapper col-lg-6 col-sm"
                 style={{
                     transform: user ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: user ? '1' : '0'
                 }}>
                <div>
                    <div className="modal-header">
                        <h3>Reset Password</h3>
                        <span className="close-modal-btn" onClick={onClose}>×</span>
                    </div>
                    {user ? (
                        <ChangePassword
                            registerUserId={user.email}
                            changePasswordUri={""}
                            currentAccount={null}
                            endForgotPassword={onClose}
                            isMobile={false}
                            isNewUser={false}
                            isAdminReset={true}
                        />
                    ) : (
                        <div>Loading...</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ResetUserPasswordModal;